export const toFormattedPrice = (num: number, fractionDigits?: number): string => {
  const digits = fractionDigits !== undefined ? fractionDigits : 2;
  return '$' + num.toLocaleString('en', { maximumFractionDigits: digits, minimumFractionDigits: digits });
};
